import { render, staticRenderFns } from "./giftcard.vue?vue&type=template&id=bc1928ba&scoped=true&"
import script from "./giftcard.vue?vue&type=script&lang=js&"
export * from "./giftcard.vue?vue&type=script&lang=js&"
import style0 from "./giftcard.vue?vue&type=style&index=0&id=bc1928ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1928ba",
  null
  
)

export default component.exports